// import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import { Grid, DialogActions, DialogContent } from '@mui/material'
import FormikControl from '../../../molecules/FormikControl'
// import FormikSelect from '../../../molecules/FormikSelect'
import SaveIcon from '@mui/icons-material/Save'
import * as Yup from 'yup'
import axios from 'axios'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import { closePopup } from '../../../../store/popupsSlice'
import { useDispatch } from 'react-redux'
import { refreshFilter } from '../../../../lib/handleFilters'
import LoadingButton from '@mui/lab/LoadingButton'
import { useState } from 'react'
import ReactQuill from 'react-quill'

const PatientNoteFactory = ({ ...values }) => {
  const dispatch = useDispatch()

  const patientId = values.patient_id
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues: {
      name: 'Notatka',
      content: '',
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      content: Yup.string().required('Pole wymagane'),
    }),
    onSubmit: async (values) => {
      store(values)
    },
  })

  const store = (values) => {
    setLoading(true)
    axios
      .post(`/patients/${patientId}/notes`, values)
      .then(() => {
        dispatch(closePopup('patient-note-factory-popup'))
        refreshFilter('PatientNotesKey')
        handleOpenAlert({
          title: 'Sukces!',
          subtitle: 'Dodano nową notatkę',
          type: 'success',
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <DialogContent dividers={true}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <FormikControl
                    variableName="name"
                    handleChange={formik.handleChange}
                    labelName="Nazwa"
                    formik={formik}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ReactQuill
                    value={formik.values.content}
                    onChange={(value) => {
                      formik.setFieldValue('content', value)
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            startIcon={<SaveIcon />}
            variant="contained"
            color="primary"
            type="submit"
            // onClick={setLoading}
            loading={loading}
            loadingPosition="start"
          >
            Zapisz
          </LoadingButton>
        </DialogActions>
      </form>
    </>
  )
}

// PatientNoteFactory.propTypes = {
//   PatientNoteFactoryProp: PropTypes.string,
// }

export default PatientNoteFactory
